import { createAction } from '@ngrx/store';
import { ProjectLocationTypes } from './project-locations.type';
import { ProjectLocationModel } from './project-locations.model';

export const getProjectLocations = createAction(
  ProjectLocationTypes.GET_PROJECT_LOCATIONS
);
export const getProjectLocationsSuccess = createAction(
  ProjectLocationTypes.GET_PROJECT_LOCATIONS_SUCCESS,
  (payload: Array<ProjectLocationModel>) => ({
    payload,
  })
);
export const getProjectLocationsCancel = createAction(
  ProjectLocationTypes.GET_PROJECT_LOCATIONS_CANCEL
);
